import $ from 'jquery';
import 'bootstrap/js/dist/tab';
import HeetsStructure from '../heets/components/heets-structure';
import RevealWhenVisible from '../../components/reveal-when-visible';
import HeetsVariantsSlider from './components/heets-variants-slider';
$(() => {
    HeetsStructure.init();
    HeetsVariantsSlider.init();
    RevealWhenVisible.init();
});
